<app-modal-header
  [highlighted]="true"
  (close)="close()">
  <span slot="breadcrumb">
    {{ 'admin.google-calendar-connection-modal.connection.title' | translate }}
  </span>
  <span slot="title">

  </span>
</app-modal-header>

<div class="modal-body">
  <div class="col-12 flex flex-column row-gap-2">
    <span class="font-bold">{{ 'admin.google-calendar-connection-modal.connection.label' | translate }}</span>
    <p-inputGroup>
      <p-inputGroupAddon class="p-1">
        <app-google-calendar-icon class="flex align-self-center justify-content-center" />
      </p-inputGroupAddon>
      <p-dropdown
        [(ngModel)]="selectedConnectionId"
        [options]="connectionOptions"
        optionLabel="title"
        optionValue="value"
        [placeholder]="'admin.google-calendar-connection-modal.connection-dropdown.placeholder' | translate"
        class="w-full input-group-dropdown"
        [class.loading-box]="fetchingConnections"
        (onChange)="onConnectionSelect($event)"
        styleClass="w-full input-group-dropdown"
      >
        <ng-template let-item pTemplate="item">
          <div class="flex flex-column row-gap-2">
            <span class="font-bold">{{ item?.title }}</span>
            <div class="details-block-wrap flex align-items-center">
              <span class="detail-block">{{ item?.label }}</span>
            </div>
          </div>
        </ng-template>
      </p-dropdown>
      <p-inputGroupAddon class="border-left-1 border-blue-500 bg-transparent">
        <label class="font-bold text-blue-500 cursor-pointer border-blue-500" (click)="onAddConnection()" [ngbTooltip]="'admin.google-calendar-connection-modal.add-connection-btn.tooltip' | translate">
          {{ 'admin.google-calendar-connection-modal.add-connection-btn.label' | translate }}
        </label>
      </p-inputGroupAddon>
    </p-inputGroup>
  </div>

  <div class="col-12 py-2">
    <span>{{ 'admin.google-calendar-connection-modal.text' | translate }}</span>
  </div>

  @if (selectedConnectionId) {
    <p-divider layout="horizontal" class="block compensate-modal-body-x-padding"></p-divider>

    <div class="col-12 flex flex-column row-gap-2" [class.loading-box]="fetchingCalendars">
      <span class="font-bold">{{ 'admin.google-calendar-connection-modal.select-calendar.label' | translate }}</span>
      <p-dropdown
        [(ngModel)]="selectedCalendarId"
        [options]="calendarsOptions"
        (onChange)="onCalendarSelect($event)"
        optionLabel="title"
        optionValue="value"
        [placeholder]="'admin.google-calendar-connection-modal.select-calendar-dropdown.placeholder' | translate"
        class="w-full"
        styleClass="w-full"
      >
        <ng-template let-item pTemplate="item">
          <div class="flex flex-column row-gap-2">
            <span class="font-bold">{{ item?.title }}</span>
            <div class="details-block-wrap flex align-items-center">
              <span class="detail-block">{{ item?.label }}</span>
              <span class="detail-block calendar-id">{{ item?.value }}</span>
            </div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  }

</div>

<div class="modal-footer justify-content-between">
  <button
    (click)="close()"
    pButton
    label="{{ 'admin.google-calendar-connection-modal.cancel-btn.label' | translate }}"
    class="p-button-sm p-button-text p-button-plain">
  </button>

  <button
    [disabled]="!selectedCalendarId || connectingCalendar"
    [loading]="connectingCalendar"
    (click)="onSubmit()"
    pButton
    label="{{ 'admin.google-calendar-connection-modal.submit-btn.label' | translate }}"
    class="p-button-sm">
  </button>
</div>
